import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

/**
 * A thin progress bar. Pass `value` as a percentage (0–100); the fill color is
 * chosen automatically (complete → blue, high → green, otherwise the accent).
 *
 * Self-contained and presentational.
 *
 * @example
 * <fb-progress-bar [value]="72" />
 */
@Component({
  selector: 'fb-progress-bar',
  templateUrl: './progress-bar.html',
  styleUrl: './progress-bar.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBar {
  /** Progress percentage, 0–100 (values outside the range are clamped). */
  readonly value = input(0);

  /** Track/fill height in pixels. */
  readonly height = input(6);

  protected readonly clampedValue = computed(() =>
    Math.max(0, Math.min(100, Math.round(this.value()))),
  );

  protected readonly color = computed(() => {
    const value = this.clampedValue();
    if (value >= 100) {
      return '#3b9fe8';
    }
    if (value > 60) {
      return '#22c37a';
    }
    return 'var(--fb-accent, #207f86)';
  });
}
